import { sectionType } from "../../../../sectionType"
import { segmentType } from "../../Corridor/models/segment-type"
import { ColumnDefinition, inclusionEnum } from "../../models/ColumnDefinition/column-definition"
import { columnType } from "./column-type.enum"
import { headType } from "./head-type.enum"

export enum variantEnum { single = 'single', left = 'left', right = 'right' };
export enum subtypeEnum { single = 'single', C = 'C' };
export enum columnSubtype { moosplaza = 'moosplaza', core = 'core', body = 'body', head = 'head' };

export const columnDefs: ColumnDefinition<columnType | headType, subtypeEnum, segmentType, variantEnum, columnSubtype>[] =
    [
        {
            type: columnType.V_P3T_XL,
            bays: 3,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P3T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P32T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLK_R]
                        }],
                    }],

                }
            ],

        },
        {
            type: columnType.V_P3T_S,
            bays: 3,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P3T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P32T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2K_R]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P3T_XS_M,
            bays: 3,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P3T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P32T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XS_C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSK_C_MK]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P4T_2M,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P4T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P42T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType._2C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType._2C_MK]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P4T_XS_S,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P4T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P42T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XS_C_S1S2]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSK_C_S1S2K]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P4T_XS_XL,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P4T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P42T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XS_C_XL]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSK_C_XLK]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P5T_SM,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P5T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P52T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2_C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2K_C_MK]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P5T_XL_M,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P5T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P52T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XL_C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLK_C_MK]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P5T_XS_2M,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P5T_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.V_P52T_R]
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XS_2C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSK_2C_MK]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.C_XS,
            bays: 1,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSBG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSBG2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XS_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSK_R]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.C_XL,
            bays: 3,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLBG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLBG2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLK_R]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.C_M,
            bays: 2,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_MBG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_MBG2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_M_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_MK_R]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.C_S1S2,
            bays: 3,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2BG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2BG2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2K_R]
                        }],
                    }],

                }
            ]
        },
        {
            type: headType.H_C_S1S2,
            bays: 3,
            columnSubtypes: [columnSubtype.head],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_S1S2BG_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_S1S2BG_2]
                        }],
                    },
                    {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_S1S2BG2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_S1S2BG2_2]
                        }],
                    }
                    ]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_S1S2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_S1S2_2]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_S1S2K_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_S1S2K_2]
                        }],
                    }],

                }
            ]
        },
        {
            type: headType.H_2C_XL,
            bays: 3,
            columnSubtypes: [columnSubtype.head],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XLBG_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XLBG_2]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XLBG2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XLBG2_2]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XL_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XL_2]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XLK_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XLK_2]
                        }],
                    }],

                }
            ]
        },
        {
            type: headType.H_2C_S1S2,
            bays: 6,
            columnSubtypes: [columnSubtype.head],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2BG_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2BG_2]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2BG2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2BG2_2]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2_2]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2K_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2K_2]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.O_X4,
            bays: 4,
            columnSubtypes: [columnSubtype.core],
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X4BG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X4BG2_R]
                        }],
                    }],
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X4_R]
                        }],
                    }],
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X4K_R]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.O_X5,
            bays: 4,
            columnSubtypes: [columnSubtype.core],
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X5BG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X5BG2_R]
                        }],
                    }],
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X5_R]
                        }],
                    }],
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X5K_R]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.O_X6,
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            bays: 4,
            columnSubtypes: [columnSubtype.core],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X6BG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X6BG2_R]
                        }],
                    }],
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X6_R]
                        }],
                    }],
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_X6K_R]
                        }],
                    }],

                }
            ]
        },

    ];
